import React, { useCallback, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useParams,
  useHistory
} from 'react-router-dom';
import { SplitPane } from 'react-multi-split-pane';
import './App.scss';

import TopToolbar from './components/layout/TopToolbar';
import OnStage from './components/layout/OnStage';
import BackStage from './components/layout/BackStage';
import SidePanel from './components/layout/SidePanel';
import SideNav from './components/layout/SideNav';
import { debounce } from 'lodash';
import { ApiService } from './services/api-service';
import { UserService } from './services/user-service';
import { AssetManagementService } from './services/asset-management-service';
import { container } from 'tsyringe';
import ChannelSelector from './components/channelSelector/ChannelSelector';

import * as R from 'ramda';
import ErrorHandlers from './components/utils/ErrorHandlers';
import { ErrorBoundary } from 'react-error-boundary';
import { Login } from './pages/login/Login';
import { Box, CircularProgress } from '@mui/material';
import { OrchestratorService } from './services/orchestrator-service';

import { EventPage } from './pages/event/Event';
import HairCheck from './components/welcome-tutos/HairCheck';
import PasswordCheck from './pages/passwordCheck/PasswordCheck';

import { identifyBrowser, isBrowserOnMobile } from './utils/helpers';
import { Mobile } from './pages/mobile/Mobile';
import { NotChrome } from './pages/notChrome/NotChrome';

import Lottie from 'react-lottie-player';
import lottieLoadingStudioJson from './assets/lottie/loading-studio.json';


interface AppProps {
  location?: any;
}

const ACCEPTED_BROWSERS = ['chrome', 'edge'];

const App = (props: AppProps) => {

  console.log = ()=> {};

  const history = useHistory();

  // Services initialization
  const [orchestratorService] = useState(container.resolve(OrchestratorService));
  const [userService] = useState(container.resolve(UserService));
  const [assetManagementService] = useState(container.resolve(AssetManagementService));
  const [globalError, setGlobalError] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [isLoadingUserInfo, setIsLoadingUserInfo] = useState(true);

  const [haircheckDone, setHaircheckDone] = useState(false);

  const [isBrowserAccepted] = useState(ACCEPTED_BROWSERS.includes(identifyBrowser(false)));
  const [isMobile] = useState(isBrowserOnMobile());

  const [isLoadingEvent, setIsLoadingEvent] = useState(true);

  useEffect(() => {

      setTimeout(() => {
          setIsLoadingEvent(false);
      }, 2000);



    // const sub = userService.jwtToken$.subscribe(t => {
    //   setIsUserLoggedIn(!!t)
    // });


    // let token = userService.bjToken$.value;
    // if (!token) {
    //   token = userService.retrieveTokenFromCookie();
    // }

    // if (token) {
    //   userService.bluejeansLoginFromToken(token)
    //     .then(_ => setIsLoadingUserInfo(false))
    //     .catch(_ => {
    //       userService.logout();
    //       history.push('/login');
    //     });
    // } else {
    //   setIsLoadingUserInfo(false);
    // }

    // return () => sub.unsubscribe();

  }, []);

  const globalErrorHandler = (error: Error, info: { componentStack: string }) => {
    console.error(error);
    console.error(info.componentStack);

    setGlobalError(true);
  };

  const globalErrorRender = ({ resetErrorBoundary }) => {
    if (!globalError) {
      resetErrorBoundary();
    }
    return <div></div>;
  };

  const loadingComponent = useCallback(() => <Box display="flex" width="100%" alignItems="center" marginTop="30%" justifyContent="center">
    <CircularProgress />
  </Box>, []);

  const loginGuard = useCallback((component: any, location: any) =>
    isLoadingUserInfo ?
      loadingComponent() :
      (isUserLoggedIn ? component : <Redirect to={{ pathname: '/login', state: { from: location } }} />),
    [isLoadingUserInfo, isUserLoggedIn, loadingComponent]);

  return <ErrorBoundary onError={globalErrorHandler} fallbackRender={globalErrorRender}>
    {isBrowserAccepted && !isMobile && <Router basename={process.env.REACT_APP_ROUTING_BASE_URL || process.env.PUBLIC_URL}>
      <Switch>
        <Route path="/">
          <EventPage></EventPage>
        </Route>
      </Switch>
    </Router>
    }
    {!isBrowserAccepted && !isMobile && <NotChrome />}
    {isMobile && <Mobile />}
    <ErrorHandlers globalError={globalError}></ErrorHandlers>


  </ErrorBoundary>;


}

export default App;
